import { AHeaderSize, AHeaderTag } from '../../atoms/AHeader/AHeader.types';
import { ABodySize } from '../../atoms/ABody/ABody.types';
import { MButton } from '../MButton/index';
import { MTextBlockSimple } from '../MTextBlockSimple/index';
import { MContentHeaderAlignment, MContentHeaderProps } from './MContentHeader.types';
import * as Styled from './MContentHeader.styles';

const COMPONENT_NAME = 'm-web-ui-kit-MContentHeader';
const TEST_ID = 'web-ui-kit-MContentHeader';

export const MContentHeader = ({ mContentHeader }: MContentHeaderProps) => {
  return (
    <Styled.ContentHeaderWrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      alignment={mContentHeader.alignment || MContentHeaderAlignment.Left}
    >
      {mContentHeader.mTextBlockSimple && (
        <MTextBlockSimple
          eyebrowText={mContentHeader.mTextBlockSimple.aEyebrow?.eyebrowText}
          headerText={mContentHeader.mTextBlockSimple.aHeader?.text}
          headerSize={(mContentHeader.mTextBlockSimple.aHeader?.size as AHeaderSize) || AHeaderSize.TitleL}
          headerTag={(mContentHeader.mTextBlockSimple.aHeader?.headerTag as AHeaderTag) || AHeaderTag.h2}
          bodyText={mContentHeader.mTextBlockSimple.aBody?.bodyText}
          bodySize={ABodySize.M}
        />
      )}
      <Styled.ButtonGroup>
        {mContentHeader.cta === 'true' && mContentHeader.mButton && (
          <MButton
            buttonText={mContentHeader.mButton.buttonText}
            variant={mContentHeader.mButton.type}
            href={mContentHeader.mButton.ctaLink}
            isExternal={mContentHeader.mButton.openInANewTab === 'true'}
          />
        )}
        {mContentHeader.secondaryCta === 'true' && mContentHeader.mButton2 && (
          <MButton
            buttonText={mContentHeader.mButton2.buttonText}
            variant={mContentHeader.mButton2.type}
            href={mContentHeader.mButton2.ctaLink}
            isExternal={mContentHeader.mButton2.openInANewTab === 'true'}
          />
        )}
      </Styled.ButtonGroup>
    </Styled.ContentHeaderWrapper>
  );
};

export type { MContentHeaderItem } from './MContentHeader.types';
export { MContentHeaderAlignment } from './MContentHeader.types';
